<form>
  <div>
    <div class="fecha"  style="float: right">{{formInput.fecha}}</div>
    <br/>
    Por la presente el suscripto, Ing. Agrónomo {{formInput.nombre}} (CJPPU N° {{formInput.CJPPU}}),
    con Cédula de Identidad {{formInput.cedula}}
    y domiciliado en  {{formInput.direccion}}, declaro hacerme técnicamente responsable por el
    desarrollo de las actividades semilleristas realizadas por la
    empresa  {{formInput.empresa}}, RUT {{formInput.rut}}, de conformidad con lo
    establecido por el artículo 65 de la Ley Nº 16.811 y demás
    normas concordantes y complementarias, por lo cual en todo lo
    relativo a las actividades: {{formInput.actividadesSeleccionadas}} llevadas a cabo por la empresa,
    asumiré responsabilidad profesional directa , pudiendo ser
    pasible de las sanciones previstas por el artículo 86 de la Ley Nº
    16.811, en caso de infracción a la normativa legal vigente.-

  </div>
</form>
